import { styled } from '@mui/material';
import Button from '@mui/material/Button';

export const Styles = {
  RectangleBar: styled('div')({
    height: '4px',
    backgroundColor: '#04682E',
    margin: '10px 0 30px 0'
  }),

  FormSection: styled('section')(({ theme }) => ({
    display: 'flex',
    gap: '20px',
    marginBottom: '30px',
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
      gap: '15px'
    },
    '&:last-child': {
      marginTop: '40px',
      justifyContent: 'flex-end',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
        gap: '10px'
      }
    }
  })),

  InputContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100% !important'
    }
  })),

  Label: styled('label')(({ theme }) => ({
    fontSize: '14px',
    fontWeight: 500,
    color: '#333',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px'
    },
    '&.required::after': {
      content: '"*"',
      color: '#ff0000',
      marginLeft: '4px'
    }
  })),

  Input: styled('input')(({ theme }) => ({
    padding: '12px',
    fontSize: '14px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    transition: 'all 0.3s ease',
    [theme.breakpoints.down('sm')]: {
      padding: '10px',
      fontSize: '13px'
    },
    '&:focus': {
      outline: 'none',
      borderColor: '#04682E',
      boxShadow: '0 0 0 2px rgba(4, 104, 46, 0.2)'
    },
    '&:disabled': {
      backgroundColor: '#f8f8f8',
      cursor: 'not-allowed'
    }
  })),

  Select: styled('select')(({ theme }) => ({
    padding: '12px',
    fontSize: '14px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    backgroundColor: '#fff',
    transition: 'all 0.3s ease',
    [theme.breakpoints.down('sm')]: {
      padding: '10px',
      fontSize: '13px'
    },
    '&:focus': {
      outline: 'none',
      borderColor: '#04682E',
      boxShadow: '0 0 0 2px rgba(4, 104, 46, 0.2)'
    }
  })),

  Button: styled(Button)(({ theme }) => ({
    padding: '12px 30px',
    fontSize: '14px',
    fontWeight: 600,
    textTransform: 'uppercase',
    backgroundColor: '#04682E',
    color: '#fff',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 20px',
      fontSize: '13px',
      width: '48%'
    },
    '&:hover': {
      backgroundColor: '#035723'
    }
  })),

  CancelButton: styled(Button)(({ theme }) => ({
    padding: '12px 30px',
    fontSize: '14px',
    fontWeight: 600,
    textTransform: 'uppercase',
    backgroundColor: '#dc3545',
    color: '#fff',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 20px',
      fontSize: '13px',
      width: '48%'
    },
    '&:hover': {
      backgroundColor: '#bb2d3b'
    }
  })),

  ImagePreview: styled('div')(({ theme }) => ({
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    overflow: 'hidden',
    border: '2px solid #ddd',
    [theme.breakpoints.down('sm')]: {
      width: '80px',
      height: '80px',
      margin: '0 auto'
    },
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  }))
};
